// Projects view + left menu glyphs: icons only this lane uses (docs/implement/lanes.md).
// Key = the icon's name, value = Lucide geometry, as in Icon.tsx.

export { projectsGlyphs };

import type { AreaGlyphs } from "../Icon";

const projectsGlyphs = {
    // The Projects page's Compact view (list rows).
    list: (
        <>
            <path d="M3 12h.01" />
            <path d="M3 18h.01" />
            <path d="M3 6h.01" />
            <path d="M8 12h13" />
            <path d="M8 18h13" />
            <path d="M8 6h13" />
        </>
    ),
    // The Projects page's Detailed view (the card grid).
    "layout-grid": (
        <>
            <rect width="7" height="7" x="3" y="3" rx="1" />
            <rect width="7" height="7" x="14" y="3" rx="1" />
            <rect width="7" height="7" x="14" y="14" rx="1" />
            <rect width="7" height="7" x="3" y="14" rx="1" />
        </>
    ),
} satisfies AreaGlyphs;
